import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'a360-avatar',
  templateUrl: 'a360-avatar.component.html',
  styleUrls: ['a360-avatar.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class A360AvatarComponent {
  @Input()
  public set originalSrc(value: string) {
    this.destinationSrc = value;
  }

  @Input()
  public altDescription = '';

  public destinationSrc: string;

  constructor() {}
}
